__turbopack_context__.v({
  "className": "nunito_d426b7dc-module__4_Nqrq__className",
  "variable": "nunito_d426b7dc-module__4_Nqrq__variable",
});
